// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import type {
  DynamicQuestionContent,
  LengthScopeDetails,
} from "@modules/service/reducer/dynamic-questions/types";
import type { StepProps } from "@components";
import * as serviceSelectors from "@modules/service/selectors";
import { Button, SchemaForm } from "@components";
import { split } from "@transformers/schema";
import { lengthScopeUiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  isLastStep: boolean,
}>;

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step4LengthScope extends React.Component<Props> {
  lengthScopeSchema = split(this.props.schema, ["durationDays", "dayType"]);

  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  handleQuestionTypeNext = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.draft, ...formData };
      this.props.onUpdateDraft(updatedDraft);
      if (this.props.handleSubmit) {
        this.props.handleSubmit(updatedDraft, true);
      }
    }
  };

  get data(): LengthScopeDetails {
    return {
      durationDays: (this.props.draft || {}).durationDays,
      dayType: (this.props.draft || {}).dayType,
    };
  }

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-8">
            {this.data && (
              <SchemaForm
                ref={this.formRef}
                className="w-100"
                formData={this.data}
                schema={this.lengthScopeSchema || {}}
                onSubmit={this.handleSubmit}
                uiSchema={lengthScopeUiSchema}
                externalSubmit
              >
                <div className="d-flex justify-content-center" />
              </SchemaForm>
            )}
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button
            materialIcon={this.props.isLastStep ? "replay_circle_filled" : "fast_forward"}
            onClick={this.handleQuestionTypeNext}
          >
            {this.props.isLastStep ? this.props.t("SUBMIT") : this.props.t("NEXT")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step4LengthScope);
